import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedRoutingModule } from './shared-routing.module';
import { ButtonComponent } from './components/button/button.component';
import { ToastComponent } from './components/toast/toast.component';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { TradingViewComponent } from './components/trading-view/trading-view.component';


@NgModule({
  declarations: [
    ButtonComponent,
    ToastComponent,
    TradingViewComponent
  ],
  imports: [
    CommonModule,
    SharedRoutingModule,
    NgbToastModule
  ],
  exports: [
    ButtonComponent,
    ToastComponent,
    TradingViewComponent
  ]
})
export class SharedModule { }
